<template>
  <section id="sso-profile-completion-drawer">
    <div class="guidelines-scroll-content">
      <h2 class="text-center">{{ content.heading }}</h2>
      <p class="text-center" v-html="content.message"></p>
    </div>
    <b-button block pill id="button-reallow-email" @click="content.btnFunc()">{{ content.btnLabel }}</b-button>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "IncompleteProfileDrawer",
  computed: {
    ...mapState("utilityStore", {
      drawerData: (state) => state.drawerData
    }),
    content() {
      return this.drawerData;
    }
  }
}
</script>

<style lang="scss" scoped>
#sso-profile-completion-drawer {
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 48px 28px 31px;

  .guidelines-scroll-content {
    overflow-y: auto;
    flex: 1;
  }

  h2 {
    color: #2F3941;
    font-family: 'SKModernistBold', sans-serif;
    font-size: 1.5rem;
    margin-bottom: 24px;
  }

  p {
    color: #68737D;
    margin-bottom: 42px;
  }

  #button-reallow-email {
    background: var(--main-color);
    border: 0;
    font-family: 'SKModernistBold', sans-serif;
    font-size: 1rem;
    height: 50px;
    margin-top: 24px;
    flex-shrink: 0;
  }
}
</style>
